const getPhoneNumberData = function (state) {
  const { phoneNumbers, phoneNumbersSIDIndexLookup } = state
  return function(phoneNumber: string) {
    return phoneNumbers[phoneNumbersSIDIndexLookup[phoneNumber]] ?? null
  }
}

export default getPhoneNumberData
